import ConfigurationInvestigationApi from 'api-client/ConfigurationInvestigation.api'

const ConfigurationInvestigationService = {
  investigate(configurationCode, options) {
    return ConfigurationInvestigationApi.investigate(configurationCode, options)
  },
}

export default ConfigurationInvestigationService
